import { Component, OnInit } from '@angular/core';
import { BaryModalEvent, IBaryModalEvent } from 'models/bary-modal-event';
import { BaryComponentHelper } from 'app/shared/util/bary-component-helper';
import { PDFSource } from 'ng2-pdf-viewer';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { MDBModalRef } from 'ng-uikit-pro-standard';

@Component({
  templateUrl: './bary-modal-browse-pdf.component.html',
  styleUrls: ['./bary-modal-browse-pdf.component.scss'],
})
export class BaryModalBrowsePdfComponent implements OnInit {
  action = BaryComponentHelper.generateAction<IBaryModalEvent>();
  message: string | undefined;
  icon: string | undefined;
  buttons = {
    submit: 'Télécharger',
    second: 'Fermer',
  };
  blobPdf?: Blob;
  filename?: string;
  title?: string;
  pdfSrc!: string | Uint8Array | PDFSource;

  constructor(public modalRef: MDBModalRef, private localStorageService: LocalStorageService, private sessionStorageService: SessionStorageService) {}

  ngOnInit(): void {
    const token: string | null = this.localStorageService.retrieve('authenticationToken') ?? this.sessionStorageService.retrieve('authenticationToken');
    this.blobPdf!.arrayBuffer().then(data => {
      this.pdfSrc = {
        data: data as Uint8Array,
        withCredentials: true,
        httpHeaders: { Authorization: `Bearer ${token}` },
      };
    });
  }

  handleClick(from: any): void {
    if (from.submit) {
      const link = URL.createObjectURL(this.blobPdf!);
      const aDom = document.createElement('a');
      aDom.setAttribute('style', 'display:none');
      aDom.setAttribute('href', link);
      aDom.setAttribute('download', this.filename ?? 'facture.pdf');
      document.body.appendChild(aDom);
      aDom.click();
      URL.revokeObjectURL(link);
      document.body.removeChild(aDom);
    }
    this.action.next(new BaryModalEvent(from));
    this.modalRef.hide();
  }
}
